import { FederationClass, League, Ranking, RankingCorrection, RankingTeam } from '@vote4dance/judging-schema';
import { DivisionId, FederationId, RankingId } from '@vote4dance/judging-types';
import { StreamSource } from "../hooks/streams";
import { DanceTeamItem } from './danceteams';

export type RankingCorrectionItem = RankingCorrection
& Pick<DanceTeamItem, 'team_name'>

export type RankingItem = Ranking
& {
    ranking_total_count: number,
    ranking_valid_count: number
}

export function RankingSource(federation_id: FederationId, division_id: DivisionId) {
    return new StreamSource<RankingItem[]>(`/federations/${federation_id}/divisions/${division_id}/rankings`);
}

export function LeagueSource(federation_id: FederationId, division_id: DivisionId, ranking_id: RankingId) {
    return new StreamSource<League[]>(`/federations/${federation_id}/divisions/${division_id}/rankings/${ranking_id}/leagues`);
}

export function RankingClassSource(federation_id: FederationId, division_id: DivisionId, ranking_id: RankingId) {
    return new StreamSource<FederationClass[]>(`/federations/${federation_id}/divisions/${division_id}/rankings/${ranking_id}/classes`);
}

export function RankingTeamSource(federation_id: FederationId, division_id: DivisionId, ranking_id: RankingId) {
    return new StreamSource<RankingTeam[]>(`/federations/${federation_id}/divisions/${division_id}/rankings/${ranking_id}/teams`);
}

export function RankingCorrectionSource(federation_id: FederationId, division_id: DivisionId, ranking_id: RankingId) {
    return new StreamSource<RankingCorrectionItem[]>(`/federations/${federation_id}/divisions/${division_id}/rankings/${ranking_id}/corrections`);
}